module.exports = __webpack_public_path__ + "img/xiaoku.24ae5324.png";